import * as React from "react";
import { Share2, Youtube, FileText } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function TeamMembersConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
        {[...Array(4)].map((_, i) => <div key={i} className="h-[400px] rounded-md bg-card animate-pulse border border-primary/20" />)}
      </div>;
  }
  if (error || posts.length === 0) {
    return null;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
      {posts.map((post, index) => {
      const artistPhoto = {
        src: post.customFields?.artist_photo || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/placeholder_artist.png",
        srcset: "",
        sizes: ""
      };
      return <Card key={post.id} data-index={index} className="group bg-card border-primary/20 hover:border-primary hover:shadow-2xl transition-all duration-500 ease-in-out overflow-hidden flex flex-col h-full rounded-md">
            <div className="pt-8 pb-4 flex justify-center relative">
              <div className="absolute inset-0 bg-gradient-to-b from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              <div className="relative w-32 h-32 rounded-md overflow-hidden shadow-md transition-colors duration-500 z-10 border-2 border-primary/30 group-hover:border-primary">
                <img src={artistPhoto.src} data-wvc-srcset={artistPhoto.srcset} data-wvc-sizes={artistPhoto.sizes} alt={post.customFields?.artist_name || post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 object-center" loading="lazy" />
              </div>
            </div>

            <CardContent className="flex-grow flex flex-col items-center text-center px-6 pb-8 relative z-10">
              <h3 className="text-xl font-bold font-default text-foreground mb-1 group-hover:text-primary transition-colors duration-500 tracking-wide">
                {post.customFields?.artist_name || post.title}
              </h3>
              <p className="text-xs text-primary font-medium mb-4 uppercase tracking-widest">
                {post.customFields?.performance_category}
              </p>
              <p className="text-sm text-muted-foreground mb-6 flex-grow font-serif leading-relaxed line-clamp-4">
                {post.customFields?.artist_bio}
              </p>
              
              <div className="mt-auto w-full flex justify-end gap-2">
                <Button asChild variant="ghost" size="icon" className="rounded-md bg-primary/5 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                  <Link to={post.customFields?.videos_link || "#"} aria-label={`Watch ${post.customFields?.artist_name}'s YouTube video`} newTab>
                    <Youtube className="w-4 h-4" />
                  </Link>
                </Button>
                <Button asChild variant="ghost" size="icon" className="rounded-md bg-primary/5 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                  <Link to={post.customFields?.cv_link || "#"} aria-label={`View ${post.customFields?.artist_name}'s CV`} newTab>
                    <FileText className="w-4 h-4" />
                  </Link>
                </Button>
                <Button asChild variant="ghost" size="icon" className="rounded-md bg-primary/5 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                  <Link to={post.link || "#"} aria-label={`View ${post.customFields?.artist_name}'s profile`}>
                    <Share2 className="w-4 h-4" />
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>;
    })}
    </div>;
}
export default function TeamMembersGrid() {
  const wp_query = new WP_Query({
    post_type: 'artist',
    posts_per_page: 10
  });
  return <section data-section-id="254278" id="artistgrid" className="py-20 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-full mx-auto mb-16">
          <div className="inline-flex items-center justify-center px-3 py-1 mb-4 text-sm font-medium rounded-md bg-primary/10 text-primary tracking-widest uppercase">
            The Roster
          </div>
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            Working With Stars
          </h2>
          <p className="text-muted-foreground text-lg font-serif italic">Discover our curated selection of world-class musicians, singers, dancers, and circus performers.</p>
        </div>

        <PostsProvider wp_query={{
        post_type: "artist",
        per_page: 10
      }}>
          <TeamMembersConsumer />
        </PostsProvider>
      </div>
    </section>;
}